export default __webpack_public_path__ + "static/media/md8-industry -4.0-vision.3e7f42ae.svg";